"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "children", "eventKey", "as"],
  _excluded2 = ["children", "eventKey", "as"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Accordion/index.js";
function Accordion(_ref) {
  var className = _ref.className,
    children = _ref.children,
    eventKey = _ref.eventKey,
    Comp = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classNames["default"])(className, 'accordion-toggle collapsed');
  return /*#__PURE__*/_react["default"].createElement(Comp, Object.assign({
    className: classes,
    href: '#' + eventKey,
    "data-bs-toggle": "collapse",
    "aria-expanded": "true"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 9
    }
  }), children);
}
Accordion.defaultProps = {
  as: 'a'
};
function Collapse(_ref2) {
  var children = _ref2.children,
    eventKey = _ref2.eventKey,
    Comp = _ref2.as,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(Comp, Object.assign({
    className: "collapse",
    id: eventKey
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }), children);
}
Collapse.defaultProps = {
  as: 'div'
};
Accordion.Collapse = Collapse;
var _default = Accordion;
exports["default"] = _default;